import axios from "axios";
import store from "../store";
import { isEmpty, showMessage, toastr } from "../cores";
import { api_url } from "../cores/keys";
import { SetCurrentPage, SetMessagePage, SetPageLoading } from "./pageAction";
import { getUserInfo, logoutUser, setCurrentUser } from "./userActions";
import { perPage, SiteName } from "../../utils";

import {
  GET_MESSAGEDATA,
  GET_DEPOSITDATA,
  GET_EXCHANGEDATA,
  GET_DEPOSIT_SUM,
  GET_WITHDRAWDATA,
  GET_WITHDRAW_SUM,
  GET_HISTORIES,
  GET_PARTNERS,
  GET_QUESTION_LIST,
  GET_DAILYCHECK_HISTORY,
  GET_DAILYCHECK_INFO,
  GET_LOTTERY_DATA,
  GET_ROULETTE_DATA,
  GET_ROULETTE_RULES,
  GET_COUPON_LIST,
  GET_EVENT_LIST,
  GET_EVENT_TYPE,
  GET_NOTICES,
  SET_PAGE_DATA,
  GET_POINT_HISTORY,
  SET_DETAIL_NOTICE,
  SET_DETAIL_EVENT,
  GET_BONUS,
  GET_REALTIME_DEPOSITE,
  GET_REALTIME_WITHDRAW
} from "./types";

export const GetMessageData = data => dispatch => {
  if (!data.noneLoading) {
    dispatch(SetPageLoading(true));
  }
  axios
    .post(api_url + "/api/notes/getList", { ...data, type: SiteName })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) return showMessage(res.data.message);

      dispatch({
        type: GET_MESSAGEDATA,
        payload: res.data
      });
      // dispatch({
      //    type: SET_PAGE_DATA,
      //    payload: res.data
      // })
      if (!data.unSetPage) {
        dispatch(SetCurrentPage(res.data));
      }
      if (isEmpty(res.data.unreadNotes)) dispatch(SetMessagePage(false));
      else dispatch(SetMessagePage(true));
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      // else
      //    toastr.warning('잠시후 다시 시도해주세요.');
    });
};

export const ConfirmMessage = data => dispatch => {
  const { unreadNotes: notes } = store.getState().more.message;

  const noteIndex = notes.findIndex(
    item => item.new === true && item._id === data
  );

  if (data !== "all" && noteIndex < 0) return;
  // dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/notes/getContent", { id: data })
    .then(res => {
      dispatch(SetPageLoading(false));

      if (res.data.status) return showMessage(res.data.message);

      const pageData = store.getState().page;
      dispatch(
        GetMessageData({ page: pageData.curPage, perPage: pageData.perPage, noneLoading: true })
      );
      // dispatch({
      //    type: GET_MESSAGEDATA,
      //    payload: res.data
      // })
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};


export const DeleteMessage = data => dispatch => {
  axios
    .post(api_url + "/api/notes/noteRemove", {})
    .then(res => {
      if (res.data.status) return showMessage(res.data.message);

      const pageData = store.getState().page;
      dispatch(
        GetMessageData({ page: 1, perPage: pageData.perPage })
      );
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const DeleteHistory = data => dispatch => {

  let url = api_url;
  switch (data.type) {
    case "interior":
    case "home_prematch":
    case "prematch":
    case "live":
    case "esport":
      url = url + "/api/Sports/deleteBettingHistory";
      break;

    case "minigame":
      url = url + "/api/Minigame/deleteBettingHistory";
      break;

    case "betgame365":
      url = url + "/api/Betgame/deleteBettingHistory";
      break;
    case "Kplay":
      url = url + "/api/Kplay/deleteBettingHistory";
      break;

    case "casino":
    case "slot":
      url = url + "/api/Slot/deleteBettingHistory";
      break;
    default:
      break;
  }
  axios
    .post(url, data)
    .then(res => {
      if (res.data.status)
        return showMessage(res.data.message);
      showMessage(res.data.message)

      const curPage = store.getState().page.curPage;
      dispatch(GetBettingHistories({
        type: data.type,
        page: curPage,
        perPage: perPage
      }))
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const getExchangeInfo = (
  amount,
  typeStr,
  withdrawPassword,
  bonus
) => dispatch => {
  // //console.log(withdrawPassword, bonus);
  dispatch(SetPageLoading(true));
  return new Promise(resolve => {
    axios
      .post(api_url + "/api/Money/getExchangeInfo", {
        amount,
        typeStr,
        withdrawPassword,
        bonus
      })
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);
        if (!res.data.status) {
          resolve(res.data);
        }
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
      });
  });
};

let isLoadingNow = false;
export const DoDeposit = (
  amount,
  typeStr,
  withdrawPassword,
  selected_bonus,
  secretKey = ""
) => dispatch => {
  if (isLoadingNow) {
    return;
  }
  dispatch(SetPageLoading(true));
  isLoadingNow = true;
  axios
    .post(api_url + "/api/Money/exchange", {
      amount,
      typeStr,
      withdrawPassword,
      selected_bonus,
      secretKey
    })
    .then(res => {
      setTimeout(() => { isLoadingNow = false }, 500);
      dispatch(SetPageLoading(false));
      if (!res.data.status) {
        if (typeStr === "deposit") {
          toastr.success(`${amount}원 입급신청되었습니다.`);
        } else {
          toastr.success(`${amount}원 환전신청되었습니다.`);
        }
        dispatch(GetDepositList(typeStr, 1));
        dispatch(getBonusList());
        dispatch(getUserInfo());
        return;
      }
      showMessage(res.data.message);
    })
    .catch(err => {
      console.error('err: ', err);
      setTimeout(() => { isLoadingNow = false }, 500);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const DeleteDeposit = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/deleteHistory", data)
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch(GetDepositList(data.typeStr, 1));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetRealTimeExchangeData = (type) => dispatch => {
  axios
    .post(api_url + "/api/Money/getRealTimeExchangeData", {
    })
    .then(res => {
      if (res.data.success == false) return showMessage(res.data.message);
      let data = res.data.exchange_list.filter(item => item.type == type);
      if(type == 1){

        dispatch({
          type: GET_REALTIME_DEPOSITE,
          payload: data
        });
      }
      else{
        dispatch({
          type: GET_REALTIME_WITHDRAW,
          payload: data
        });
      }
    })
    .catch(err => {
      console.error('err: ', err);
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
    });
};

export const GetDepositList = (typeStr, page) => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getHistory", {
      typeStr,
      page: page,
      perPage: store.getState().page.perPage
    })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) return showMessage(res.data.message);
      dispatch({
        type: GET_DEPOSITDATA,
        payload: res.data.histories
      });
      dispatch({
        type: GET_DEPOSIT_SUM,
        payload: res.data.sum
      });
      dispatch(SetCurrentPage(res.data));
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      // else
      //    toastr.warning('잠시후 다시 시도해주세요.');
    });
};

//Royce에서 입출금목록 
export const GetRoyceDepositList = (typeStr, page) => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getRoyceHistory", {
      typeStr,
      page: page,
      perPage: store.getState().page.perPage
    })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) return showMessage(res.data.message);
      dispatch({
        type: GET_DEPOSITDATA,
        payload: res.data.histories
      });
      dispatch({
        type: GET_DEPOSIT_SUM,
        payload: res.data.sum
      });
      dispatch(SetCurrentPage(res.data));
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      // else
      //    toastr.warning('잠시후 다시 시도해주세요.');
    });
};

export const GetWithDrawList = (typeStr, page) => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getHistory", {
      typeStr,
      page: page,
      perPage: store.getState().page.perPage
    })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) return showMessage(res.data.message);
      dispatch({
        type: GET_WITHDRAWDATA,
        payload: res.data.histories
      });
      dispatch({
        type: GET_WITHDRAW_SUM,
        payload: res.data.sum
      });
      dispatch(SetCurrentPage(res.data));
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      // else
      //    toastr.warning('잠시후 다시 시도해주세요.');
    });
};

export const GetPointHistory = (page = 1) => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getPointHistory", { page, perPage: store.getState().page.perPage })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) {
        return showMessage(res.data.message);
      }
      else {
        dispatch({
          type: GET_POINT_HISTORY,
          payload: res.data.histories
        });
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetExchangeData = (page = 1) => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getRollingHistory", { page, perPage: store.getState().page.perPage })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) return showMessage(res.data.message);
      dispatch({
        type: GET_EXCHANGEDATA,
        payload: res.data.histories
      });
      dispatch(SetCurrentPage(res.data));
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const DeleteExchange = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/deleteRollingHistory", data)
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch(GetExchangeData(data.type));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

let flag = true;
export const DoExchange = money => dispatch => {
  if (flag) {
    flag = false;
    dispatch(SetPageLoading(true));
    axios
      .post(api_url + "/api/Money/rollingChange", {
        amount: money
      })
      .then(res => {
        setTimeout(() => {
          flag = true;
        }, 1000);
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);
        if (!res.data.status) {
          dispatch(GetExchangeData(store.getState().page.curPage));
          dispatch(getUserInfo());
        }
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
      });
  }
};

export const GetBettingHistories = data => dispatch => {
  if (data.clear) {
    dispatch({
      type: GET_HISTORIES,
      payload: { bets: [] }
    });
  }

  dispatch(SetPageLoading(true));
  let url = api_url;
  switch (data.type) {
    case "interior":
    case "home_prematch":
    case "prematch":
    case "live":
    case "esport":
      url = url + "/api/Sports/getBettingHistory";
      break;
    case "Kplay":
      url = url + "/api/Kplay/getBettingHistory";
      break;

    case "minigame":
      url = url + "/api/Minigame/getBettingHistory";
      break;

    case "betgame365":
      url = url + "/api/Betgame/getBettingHistory";
      break;

    case "casino":
    case "slot":
      url = url + "/api/Slot/getBettingHistory";
      break;
    default:
      break;
  }
  if (data.type)
    axios
      .post(url, { ...data })
      .then(res => {
        dispatch(SetPageLoading(false));

        if (!res.data.status) {
          dispatch({
            type: GET_HISTORIES,
            payload: res.data
          });
          // dispatch({
          //    type: SET_PAGE_DATA,
          //    payload: res.data
          // })
          dispatch(SetCurrentPage(res.data));
        }
        else {
          showMessage(res.data.message);
        }
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
      });
};

export const GetPartnerData = data => dispatch => {
  dispatch(SetPageLoading(true));
  // //console.log(data)
  axios
    .post(api_url + "/api/Users/getPartnerLinkers ", { ...data, perPage: store.getState().page.perPage })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (res.data.status) {
        dispatch({
          type: GET_PARTNERS,
          payload: res.data.users
        });
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const HidePopup = id => dispatch => {
  dispatch(SetPageLoading(false));
  axios
    .post(api_url + "/api/popup/hide", { id })
    .then(res => {
      dispatch(SetPageLoading(false));
      if (res.data.status) showMessage(res.data.message);
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const DoQuestion = data => dispatch => {
  return new Promise(resolve => {
    dispatch(SetPageLoading(true));
    axios
      .post(api_url + "/api/Question/send", data)
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);
        if (!res.data.status) {
          resolve();
        }
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
      });
  });
};

export const GetQuestionList = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Question/getList", { ...data })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch({
          type: GET_QUESTION_LIST,
          payload: res.data.questions
        });
        // dispatch({
        //    type: SET_PAGE_DATA,
        //    payload: res.data
        // })
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const InitMoreData = () => dispatch => {
  dispatch({
    type: GET_DAILYCHECK_HISTORY,
    payload: {
      aDayMoney: 0,
      bDayMoney: 0,
      cDayMoney: 0,
      depositLimit: 0,
      currentMonthAttendanceCount: 0,
      history: []
    }
  });
  dispatch({
    type: GET_LOTTERY_DATA,
    payload: {
      history: [],
      leftCount: 0
    }
  });
  dispatch({
    type: GET_ROULETTE_DATA,
    payload: {
      history: [],
      leftCount: 0
    }
  });
  dispatch({
    type: GET_COUPON_LIST,
    payload: []
  });
  // dispatch({
  //    type: GET_HISTORIES,
  //    payload: {bets: []}
  // })
};

export const GetDailyCheckHistory = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Attendance/history", data)
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch({
          type: GET_DAILYCHECK_HISTORY,
          payload: res.data
        });
        // dispatch({
        //    type: SET_PAGE_DATA,
        //    payload: res.data
        // })
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetDailyCheckInfo = () => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Attendance/info", {})
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch({
          type: GET_DAILYCHECK_INFO,
          payload: res.data.attendance
        });
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetLotteryHistory = page => dispatch => {
  const pageData = store.getState().page
  // dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Lottery/history", { page: page, perPage: pageData.perPage })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch({
          type: GET_LOTTERY_DATA,
          payload: res.data
        });
        // dispatch({
        //    type: SET_PAGE_DATA,
        //    payload: res.data
        // })
        dispatch(getUserInfo());
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const DoLottery = all => dispatch => {
  return new Promise(resolve => {
    dispatch(SetPageLoading(true));
    axios
      .post(api_url + "/api/Lottery/scrap", { all })
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);

        if (!res.data.status) {
          // dispatch(GetLotteryHistory(1));
          // dispatch(getUserInfo());
          let sum = 0;
          for (let i = 0; i < res.data.history.length; i++)
            sum += isEmpty(res.data.history[i].bonus)
              ? 0
              : res.data.history[i].bonus.balance.rolling;
          resolve({
            success: true,
            bonus: sum
          });
        }
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
        resolve({
          success: false
        });
      });
  });
};

export const GetRouletteHistory = page => dispatch => {
  const pageDate = store.getState().page;
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Roulette/history", { page, perPage: pageDate.perPage })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch({
          type: GET_ROULETTE_DATA,
          payload: res.data
        });
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetRouletteRules = () => dispatch => {
  return new Promise(resolve => {
    dispatch(SetPageLoading(true));
    axios
      .post(api_url + "/api/Roulette/info", {})
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);

        if (!res.data.status) {
          dispatch({
            type: GET_ROULETTE_RULES,
            payload: res.data
          });
          return resolve({
            success: true,
            roulette: res.data.roulette.list
          });
        }
        resolve({
          success: false
        });
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
        resolve({
          success: false
        });
      });
  });
};

export const DoRoulette = page => dispatch => {
  return new Promise(resolve => {
    dispatch(SetPageLoading(true));
    axios
      .post(api_url + "/api/Roulette/open", {})
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);

        if (!res.data.status) {
          // dispatch(GetRouletteHistory());
          // dispatch(getUserInfo());
          return resolve({
            success: true,
            bonus: res.data.history.bonus
          });
        }
        return resolve({
          success: false
        });
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
        return resolve({
          success: false
        });
      });
  });
};

export const GetCouponList = () => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Coupon/list", {})
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch({
          type: GET_COUPON_LIST,
          payload: res.data.list
        });
        // dispatch(setCurrentUser(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const useCoupon = id => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Coupon/use", { id })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);

      if (!res.data.status) {
        dispatch(GetCouponList());
        dispatch(getUserInfo());
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetEventType = () => dispatch => {
  dispatch(SetPageLoading(true));
  return new Promise(resolve => {
    axios
      .post(api_url + "/api/Post/type", { type: SiteName })
      .then(res => {
        dispatch(SetPageLoading(false));
        showMessage(res.data.message);

        if (!res.data.status) {
          dispatch({
            type: GET_EVENT_TYPE,
            payload: res.data.types
          });
          return resolve({
            success: true
          });
        }
        return resolve({
          success: false
        });
      })
      .catch(err => {
        console.error('err: ', err);
        dispatch(SetPageLoading(false));
        if (err.response && err.response.status === 401) {
          dispatch(logoutUser());
        }
        else toastr.warning("잠시후 다시 시도해주세요.");
        return resolve({
          success: false
        });
      });
  });
};

export const GetEventList = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Post/list", {
      ...data,
      type: SiteName,
      site: SiteName
    })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch({
          type: GET_EVENT_LIST,
          payload: res.data.list
        });
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetNoticeList = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Notice/list", { ...data, type: SiteName })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch({
          type: GET_NOTICES,
          payload: res.data.list
        });
        // dispatch({
        //    type: SET_PAGE_DATA,
        //    payload: res.data
        // })
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const GetLoginNoticeList = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/notice/list", { ...data })
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch({
          type: GET_NOTICES,
          payload: res.data.list
        });
        // dispatch({
        //    type: SET_PAGE_DATA,
        //    payload: res.data
        // })
        dispatch(SetCurrentPage(res.data));
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const getBonusList = data => dispatch => {
  dispatch(SetPageLoading(true));
  axios
    .post(api_url + "/api/Money/getBonusList", {})
    .then(res => {
      dispatch(SetPageLoading(false));
      showMessage(res.data.message);
      if (!res.data.status) {
        dispatch({
          type: GET_BONUS,
          payload: res.data.bonus_list
        });
      }
    })
    .catch(err => {
      console.error('err: ', err);
      dispatch(SetPageLoading(false));
      if (err.response && err.response.status === 401) {
        dispatch(logoutUser());
      }
      else toastr.warning("잠시후 다시 시도해주세요.");
    });
};

export const setNoticeDetail = noticeId => dispatch => {
  dispatch({
    type: SET_DETAIL_NOTICE,
    payload: noticeId
  });
}
export const setEventDetail = eventId => dispatch => {
  dispatch({
    type: SET_DETAIL_EVENT,
    payload: eventId
  });
}



// WEBPACK FOOTER //
// ./src/common/actions/moreAction.js